<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.vendors.edit_vendor_dimensions')"
  :subtitle="$t('companies.vendors.edit_vendor_dimensions')"
  :rightActions="rightActions"
  width="1000"
)
  UiStack(vertical)
    UiStackItem
      UiButton(
        variant="primary"
        @click="addDimensionItem"
        icon="Plus"
      ) {{ $t("actions.add") }}

    RestTable(
      namespace="vendor_dimensions"
      :headers="headers"
      ref="vendorDimensionsTable"
      :fetch-handler="getData"
      :itemsPerPageAttachDropdownToBody="false"
      embed
    )
      template(#cell:not_suggest="{ item }")
        UiCheckbox(
          v-model="item.not_suggest"
          switch
          @update:modelValue="changeNotSuggest(item)"
        )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiStackItem
            UiButton(
              size="sm"
              variant="smooth-danger"
              @click="deleteDimensionItem(item)"
              icon="Trash"
            ) {{ $t("actions.delete") }}
  AddVendorDimensionModal(
    ref="AddVendorDimensionModal"
    @done="reloadVendorDimensions()"
  )
</template>

<script>
import ApiVendorDimensionItems from "@/api/vendorDimensionItems.js";
import AddVendorDimensionModal from "@/modals/Companies/addVendorDimension.vue";

export default {
  components: {
    AddVendorDimensionModal,
  },

  data() {
    return {
      show: false,
      companyId: null,
      vendorId: null,
      form: {},
      headers: [
        {
          key: "id",
          label: "#",
          squeeze: true,
        },
        {
          key: "dimension_name",
          label: "Dimension",
          squeeze: false,
        },
        {
          key: "name",
          label: "Dimension Item",
          squeeze: false,
        },
        {
          key: "not_suggest",
          label: "Don't suggest item",
          squeeze: false,
        },
        {
          key: "actions",
          label: "#",
          squeeze: false,
        },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.close,
        },
      ];
    },
  },

  methods: {
    open(companyId, Vendor) {
      this.companyId = companyId;
      this.vendorId = Vendor.id;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    reloadVendorDimensions() {
      this.$refs.vendorDimensionsTable.fetchData();
    },

    getData(params, config) {
      return ApiVendorDimensionItems.fetchDimensionItems(
        this.companyId,
        this.vendorId,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.vendorDimensions,
          meta: resp.data.meta,
        };
      });
    },

    deleteDimensionItem(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description:
          this.$t("actions.confirm_remove") +
          " " +
          item.dimension_name +
          " " +
          item.name,
        variant: "danger",
        icon: "trash-can",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiVendorDimensionItems.deassignDimensionItem(
          this.companyId,
          this.vendorId,
          item.id,
        ).then((resp) => {
          this.reloadVendorDimensions();
        });
      });
    },

    addDimensionItem() {
      this.$refs.AddVendorDimensionModal.open(this.companyId, this.vendorId);
    },

    changeNotSuggest(item) {
      this.saveItem(item.id, {
        vendor_dimension_item: { not_suggest: item.not_suggest },
      });
    },

    saveItem(id, params) {
      ApiVendorDimensionItems.updateVendorDimensionItem(
        this.$route.params.id,
        id,
        params,
      ).then((resp) => {
        this.reloadVendorDimensions();
      });
    },
  },
};
</script>
